<script>

export default {
  name: 'ServicesBlock',
  data() {
    return {
      propertyName: 'Primary Home'
    }
  },
  computed: {
    // Mock data -- ideally coming from api request
    services() {
      // Hardcoded but this could be a cookie
      return {
        active: [
          {name: '360 Virtual Tour', qty: ''},
          {name: 'Base Interior Package', qty: ''},
          {name: 'Total Room/Area Documented', qty: '10 areas'},
          {name: 'Detailed Items', qty: '20 items'},
          {name: 'Auto Item Recognition', qty: '40 items'},
          {name: 'Total Categories Documented', qty: '3 Categories'}
        ],
        recommended: [
          {name: 'Base Exterior Roof', qty: ''},
          {name: 'Total Room/Area Undocumented', qty: '4 areas'},
          {name: 'Valuation Services', qty: ''},
          {name: 'Undocumented Auto Item Recognition', qty: '80 items'},
          {name: 'Total Categories Documented', qty: '24 categories'},
          {name: 'Estate Management Service', qty: ''},
          {name: 'Insurance Valuation Service', qty: ''},
          {name: 'Resell Marketplace Service', qty: ''},
          {name: 'Market My Home Services', qty: ''},
          {name: 'Inventory Audit', qty: ''},
          {name: 'Charitable Contribution', qty: ''},
        ]
      }
    }
  },
}
</script>

<style>
  .services-block.widget {
    background-color: #d7dce3;
    border:  1px solid #37518b;
  }

  .services-block.widget .block-title {
    color: #253762;
    text-align: center;
    text-decoration: underline;
  }

  .services-block.widget .active h5 {
    margin-left: 1rem;
    color: #51af62;
  }

  .services-block.widget .recommended h5 {
    margin-top: 1rem;
    margin-left: 1rem;
    color: #e53529;
  }

  .services-block.widget table {
    margin-left: 1rem;
    width: 100%;
  }

  .services-block.widget table td {
    width: 65%;
  }

  .services-block.widget table td.qty {
    width: 35%;
  }

  .services-block.widget .order-services .btn {
    float: right;
  }
</style>

<template>
  <aside class="services-block widget mt-2 p-2">
    <h4 class="block-title p-1 mt-1">
      Services Overview: {{ propertyName }}
    </h4>
    <b-row>
      <b-col class="active" v-if="services.active">
        <h5>Active</h5>
        <table>
          <tr v-for="(item, index) in services.active" :key="index">
            <td><b-link>✓ {{ item.name }}</b-link></td><td class="qty">{{ item.qty }}</td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="recommended" v-if="services.recommended">
        <h5>Recommended</h5>
        <table>
          <tr v-for="(item, index) in services.recommended" :key="index">
            <td><b-link>❑ {{ item.name }}</b-link></td><td class="qty">{{ item.qty }}</td>
          </tr>
        </table>
      </b-col>
      <div class="order-services">
        <b-button class="px-2" variant="primary" href="https://mypropertyvault.com/our-services/" target="_blank">
          Order Services
        </b-button>
      </div>
    </b-row>
  </aside>
</template>